var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.927 4.717c.275-.611.993-.884 1.605-.61 3.636 1.626 5.627 5.519 4.77 9.35C19.447 17.282 15.99 20 12 20c-3.99 0-7.447-2.718-8.302-6.543-.857-3.831 1.134-7.724 4.77-9.35a1.211 1.211 0 1 1 .993 2.212c-2.59 1.158-3.997 3.91-3.393 6.61.605 2.708 3.072 4.647 5.932 4.647 2.86 0 5.327-1.939 5.932-4.647.604-2.7-.803-5.452-3.393-6.61a1.211 1.211 0 0 1-.612-1.602Z",
  fill: "#231F20",
  fillRule: "nonzero"
})));
export default SvgSpinner;